import { physicalFormatsConstants } from '../constants/physical_formats';

export function physicalFormats(state = {}, action) {
	switch (action.type) {			
		case physicalFormatsConstants.GET_PHYSICAL_FORMATS_REQUEST:
			return {
				...state,
				physicalFormatsLoading: true,
			};
		case physicalFormatsConstants.GET_PHYSICAL_FORMATS_SUCCESS:
			return {

				...state,
				physicalFormatsLoading: false,
				physicalFormats: action.physicalFormats,
			};
		case physicalFormatsConstants.GET_PHYSICAL_FORMATS_FAILURE:
			return {
				...state,
				physicalFormatsLoading: false,
				error: action.error
			};  
			
		default:
			return state
	}
}
